import { Injectable } from '@angular/core';

const LOCAL_STORAGE_APP_PREFIX = 'serv-e-go';

@Injectable()
export class LocalStorageService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private readonly storage: any;

    constructor() {
        if (window.localStorage) {
            this.storage = window.localStorage;
        } else {
            throw Error('No Local storage available on this browser');
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getItem(key: string): any {
        try {
            let item = this.storage.getItem(`${LOCAL_STORAGE_APP_PREFIX}-${key}`);
            if (item === 'undefined') {
                item = undefined;
            } else {
                item = JSON.parse(item);
            }
            return item;
        } catch (error) {
            console.error(`Error at LocalstorageService.getItem() for key "${key}"`);
            console.error(error);
            throw new Error(String(error));
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setItem(key: string, value: any): void {
        this.storage.setItem(`${LOCAL_STORAGE_APP_PREFIX}-${key}`, JSON.stringify(value));
    }
}
